export const FETCH_EVENTS_SUCCESS = "app/events/FETCH_EVENTS_SUCCESS";
export const FETCH_EVENTS_FAIL = "app/events/FETCH_EVENTS_FAIL";